import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const employeeRoleApi = createApi({
  reducerPath: 'employeeRoleApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/v1/employee_roles' }),
  endpoints: (builder) => ({
    getEmployeeRoles: builder.query({
      query: (searchParams = '') => searchParams
    }),
    getEmployeeRole: builder.query({
      query: (id) => `/${id}`
    })
  })
})

export const { useGetEmployeeRolesQuery, useGetEmployeeRoleQuery } = employeeRoleApi
